import { YinzCamAPI, YinzCamAPIRequest } from 'yinzcam-api';
import { register } from 'yinzcam-registry';
import { APP_SERVER_REGISTRY } from './constants';
import { YinzCamNBAAppServer } from './YinzCamNBAAppServer';

@register(APP_SERVER_REGISTRY, 'nbad')
export class YinzCamNBADAppServer extends YinzCamNBAAppServer {
  public constructor(api: YinzCamAPI) {
    super(api);
  }
}